import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import {
  FDAccordionGroup, FDSecondaryActionButton, FDSimpleAccordion, Table,
} from '@facet-wealth/design';
import TableBody from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Table/TableBody';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import fr from 'facet-rest';

const styles = (theme) => ({
  root: {
    padding: theme.spacing(2),
    margin: theme.spacing(2),
    backgroundColor: theme.palette.facet.whiteSmoke,
    borderRadius: theme.radius.md,
  },
  addButton: {
    marginBottom: theme.spacing(2),
  },
});

const State529ConfigByDateSectionSection = ({
  className,
  classes,
  stateConfigResources,
}) => {
  const {
    loadModalCollectionByLink,
  } = useModalContext();

  const handleModifyAssumption = React.useCallback(
    assumptionEntry => {
      const selfLink = assumptionEntry.link('self');
      if (selfLink) {
        const assumptionEntrySelfLink = selfLink.url();
        loadModalCollectionByLink(assumptionEntrySelfLink);
      }
    },
    [stateConfigResources],
  );

  const handleAddAssumptionEntry = React.useCallback(
    assumption => {
      if (assumption.relationship(fr.relationships.addAssumptionEntry.name)) {
        const addLink = assumption.relationship(fr.relationships.addAssumptionEntry.name).link('related').url();
        loadModalCollectionByLink(addLink);
      }
    },
    [stateConfigResources],
  );

  const attrs = [
    'startDate',
    'formattedDeductionLimitSingle',
    'formattedDeductionLimitJoint',
    'formattedDeductionLimitPerBeneficiary',
    'formattedPercentOfContribution',
    'isTaxCredit',
    'changedByPersonName',
  ];

  return (
    <Box className={classNames(classes.root, className)}>
      <FDAccordionGroup>
        {stateConfigResources.map(config => {
          const entries = config.attr('facetPlanStateSponsored529PlanConfigurationByDateEntries').resources().list();
          if (entries.length === 0) {
            return null;
          }

          const firstEntry = entries[0];

          return (
            <FDSimpleAccordion
              key={config.id()}
              expansionID={config.attr('stateName')}
              title={config.attr('stateName')}
            >
              <Box className={classNames(classes.addButton)}>
                <FDSecondaryActionButton
                  icon="add"
                  iconPosition="start"
                  label="Add New Entry"
                  onClick={config.relationship(fr.relationships.addAssumptionEntry.name) ? () => handleAddAssumptionEntry(config) : null}
                  size="sm"
                />
              </Box>
              <Table.Table size="lg">
                <Table.HeadColumnHeaderSet>
                  {attrs.map(attr => {
                    return (<Table.HeadColumnHeaderCell value={firstEntry?.meta().field(attr).attr('prompt')} />);
                  })}
                </Table.HeadColumnHeaderSet>
                <TableBody>
                  {entries.map(entry => {
                    return (
                      <Table.BodyRow key={entry.id()} onClick={entry.link('self') ? () => handleModifyAssumption(entry) : null}>
                        {attrs.map(attr => (
                          <Table.BodyCellText value={entry.attr(attr)} />
                        ))}
                      </Table.BodyRow>
                    );
                  })}
                </TableBody>
              </Table.Table>
            </FDSimpleAccordion>
          );
        })}
      </FDAccordionGroup>
    </Box>
  );
};

State529ConfigByDateSectionSection.defaultProps = {
  className: '',
};

State529ConfigByDateSectionSection.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  stateConfigResources: PropTypes.array.isRequired,
};

export default withStyles(styles)(State529ConfigByDateSectionSection);
